import './jp-links.less';
import type {Link} from 'typings/portaro.fe.types';

export class JpLinksComponentController {
    public singleButtonOverwriteLinkText: string;
    public singleButtonPrefixText: string;
    public buttonSize = 'sm';

    public adjustLink(link: Link): Link {
        if (this.singleButtonOverwriteLinkText) {
            link.text = this.singleButtonOverwriteLinkText;
        }

        if (this.singleButtonPrefixText) {
            link.text = this.singleButtonPrefixText + link.text;
        }

        return link;
    }
}

/**
 * @ngdoc component
 * @name jpLinks
 * @module portaro.components
 *
 * @param {Link[]} links Links
 * @param {boolean=} jpShowIfEmpty
 * @param {string=} jpDropdownButtonText
 * @param {string=} jpSingleButtonOverwriteLinkText
 * @param {string=} jpSingleButtonPrefixText
 * @param {boolean=} forceDropdown If it is true, component show dropdown button even if it showing only one link.
 * @param {string=} [jpButtonSize='sm'] Button size
 *
 * @description
 * It renders dropdown of links with `jp-dropdown-button-text` label.
 * If link is only one, it renders classic button with link, except if `force-dropdown` is `false` or not set.
 * If classic button is rendered, it is possible to prepend link text with `jp-single-button-prefix-text` or completely replace it with `jp-single-button-overwrite-link-text`.
 * It can be combined.
 */
// eslint-disable-next-line max-classes-per-file
export default class JpLinksComponent {
    public static componentName = 'jpLinks';

    public templateUrl = require('./jp-links.tpl.pug');

    public bindings = {
        links: '<',
        showIfEmpty: '<jpShowIfEmpty',
        dropdownButtonText: '<jpDropdownButtonText',
        singleButtonOverwriteLinkText: '<?jpSingleButtonOverwriteLinkText',
        singleButtonPrefixText: '<?jpSingleButtonPrefixText',
        forceDropdown: '<?',
        buttonSize: '@?jpButtonSize'
    };

    public controller = JpLinksComponentController;
}
